// @ts-nocheck
import * as React from "react";

const Instagram: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g fill="currentColor" clipPath="url(#a)">
                <path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z" />
                <path d="M18.76 23.517h-7.522a4.763 4.763 0 0 1-4.758-4.758v-7.52a4.763 4.763 0 0 1 4.758-4.758h7.522a4.763 4.763 0 0 1 4.758 4.758v7.522a4.763 4.763 0 0 1-4.758 4.758v-.002ZM11.238 7.862a3.38 3.38 0 0 0-3.377 3.377v7.522a3.38 3.38 0 0 0 3.377 3.377h7.522a3.38 3.38 0 0 0 3.377-3.377V11.24a3.38 3.38 0 0 0-3.377-3.377h-7.522Z" />
                <path d="M14.999 19.483A4.488 4.488 0 0 1 10.516 15a4.486 4.486 0 0 1 4.483-4.483A4.486 4.486 0 0 1 19.482 15a4.486 4.486 0 0 1-4.483 4.483Zm0-7.585A3.105 3.105 0 0 0 11.897 15a3.107 3.107 0 0 0 3.102 3.102A3.105 3.105 0 0 0 18.1 15a3.107 3.107 0 0 0-3.102-3.102ZM19.667 11.027a.7.7 0 1 1 .002-1.398.7.7 0 0 1-.002 1.398Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Instagram);
